export default __webpack_public_path__ + "static/media/emprise-bank-logo.6e076bb3.svg";